import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';

const Localize = (props) => <Translate {...props} />;

export default Localize;
export { withLocalize };
